<form
  [formGroup]="updateEmployeeResp"
  (ngSubmit)="onupdateEmployeeResp()"
>
  <p-table
    #dt1
    [value]="allEmployees"
    dataKey="id"
    [rows]="50"
    [showCurrentPageReport]="true"
    [rowsPerPageOptions]="[10, 25, 50]"
    [loading]="loading"
    styleClass="p-datatable-customers p-datatable-gridlines marge-sections"
    [paginator]="true"
    currentPageReportTemplate="Prikaz od {first}. do {last}. zaposlenog od ukupno {totalRecords}"
    [globalFilterFields]="['fname', 'lname']"
  >
    <ng-template pTemplate="caption">
      <div class="page-control">
        <span class="p-input-icon-left">
          <i class="pi pi-search"></i>
          <input
            pInputText
            type="text"
            (input)="dt1.filterGlobal($event.target.value, 'contains')"
            placeholder="Pretraži id, naziv, oznaku..."
          />
        </span>
        <div class="btn-group">
          <button
            class="main-btn"
            type="submit"
            [ngClass]="{ disabled: !updateEmployeeResp.valid }"
            [disabled]="!updateEmployeeResp.valid"
          >
            Snimi <i class="pi pi-save"></i>
          </button>
        </div>
      </div>
    </ng-template>

    <ng-template pTemplate="header">
      <tr>
        <th>
          <div class="flex justify-content-between align-items-center">
            Radnik
          </div>
        </th>
        <th>
          <div class="flex justify-content-between align-items-center">
            Operacije
          </div>
        </th>
        <th>
          <div class="flex justify-content-between align-items-center">
            Email
          </div>
        </th>
      </tr>
    </ng-template>

    <ng-template
      pTemplate="body"
      let-employee
      let-index="rowIndex"
    >
      <tr>
        <td>{{ employee.fname }} {{ employee.lname }}</td>
        <td>
          <div
            class="field mb-0 flex flex-wrap"
            *ngIf="allOperations"
          >
            <div
              class="field-checkbox mr-3 mb-0"
              *ngFor="let item of allOperations"
            >
              <input
                type="checkbox"
                [checked]="employee.assignments.includes(item.id)"
                [value]="item.id"
                (change)="onCheckItem(item.id, index)"
              />
              <label for="ny">{{ item.label }}</label>
            </div>
          </div>
        </td>
        <td>
          <span>{{ employee.email }}</span>
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="3">Ni jedan zaposleni nije pronađen.</td>
      </tr>
    </ng-template>
  </p-table>
</form>
